<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入任务名称查询" v-model="queryObj.keyWord" size="small" class="query" style="float: left" clearable
        @change="() => { this.queryObj.pageNum = 1; init() }">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right:6px"
        @click="add_init">新增</el-button>

      <es-delete @del="del()" type="button"></es-delete>

    </div>
    <el-table :data="pageData.list" ref="typeTable" border stripe size="mini" height="calc(100vh - 180px)"
      style="cursor: pointer;" @current-change="showDetail" v-loading="loading">
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="name" label="任务名称">
      </el-table-column>
      <el-table-column prop="name" label="证书名称">
      </el-table-column>
      <el-table-column prop="name" label="培训名称">
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
              class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)" :key="scope.row.id" type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData" @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadTypeList() }">
      </es-pagination>
    </div>

    <!--编辑设备类型-->
    <el-dialog :close-on-click-modal="false" :visible.sync="editVisible" @closed="() => this.$refs['typeForm'].clearValidate()" width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑任务类型
      </span>
      <el-form :model="typeInfo" :rules="rules" size="mini" label-position="right" label-width="150px" ref="typeForm">
        <el-form-item prop="name" label="任务名称">
          <el-input v-model="typeInfo.name" placeholder="请输入任务名称" style="width:200px" clearable>
          </el-input>
        </el-form-item>
      </el-form>
       <div>
    <el-select v-model="selectedOptions" multiple placeholder="请选择城市" @change="handleChange">
      <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value"></el-option>
    </el-select>
    <div v-for="(option, index) in selectedOptions" :key="index">
      <span>{{ option }}：</span>
      <el-input-number v-model="quantities[option]" :min="0"></el-input-number>
    </div>
  </div>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitType()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'certificate',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      typeInfo: {},//设备类型信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
      options: [
        { value: 'beijing', label: '北京' },
        { value: 'shanghai', label: '上海' },
      ],
      selectedOptions: [],
      quantities: {},
    }
  },
  methods: {
    handleChange(value) {
      // 在选择项发生改变时更新selectedOptions数组
      this.selectedOptions = value
    },
    //页面初始化
    init () {
      this.loadTypeList()
    },
    //从后台查询设备类型
    loadTypeList () {
      this.loading = true
      this.$ajax.get('/base/certi/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //初始化添加设备类型
    add_init () {
      this.editVisible = true
      this.typeInfo = {
      }
    },
    //初始化编辑设备类型
    edit_init (row) {
      this.editVisible = true
      this.typeInfo = JSON.parse(JSON.stringify(row))
    },
    //保存设备类型
    submitType () {
      this.$refs["typeForm"].validate(valid => {
        if (valid) {
          let url = "/base/certi/add";
          if (this.typeInfo.id != null) {
            url = "/base/certi/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.typeInfo).then(msg => {
            this.saving = false
            this.loadTypeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除设备类型
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["typeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/certi/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadTypeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>

</style>
